import ApplyStepButtons from 'components/ApplyStepButtons'
import ApplyStepIcon from 'components/ApplyStepIcon'

import s from './ApplyOpenCallNotes.module.css'

//TODO: setup proptypes
function ApplyOpenCallNotes({ expectations, caution, back, next }) {
  return (
    <div className={s.container}>
      <div className={s.columns}>
        <div className={s.column}>
          <h1 className={s.title}>What to expect</h1>
          <div
            className={s.text}
            dangerouslySetInnerHTML={{ __html: expectations }}
          />
        </div>
        <div className={s.column}>
          <h1 className={s.title}>Caution</h1>
          <div
            className={s.text}
            dangerouslySetInnerHTML={{ __html: caution }}
          />
        </div>
      </div>
      <ApplyStepButtons back={back} next={next} />
      <ApplyStepIcon step="2" />
    </div>
  )
}

export default ApplyOpenCallNotes
